import "./index.scss"

import { Controller as StimulusController } from "stimulus";

export class Controller extends StimulusController {
	static targets = [ "input", "errorIcon", "errorMessages" ];

	removeErrors() {
		if (this.inputTarget.classList.contains("invalid")) {
			this.inputTarget.classList.replace("invalid", "valid");
			this.errorIconTarget.classList.add("hidden");
			this.errorMessagesTarget.classList.add("hidden");
		}
	}
}
